import { Link, Section } from '@arp/react-ndbx';
import ArrowBackIcon from '@mui/icons-material/KeyboardBackspaceRounded';
import { Box, Modal, Typography } from '@mui/material';
import useTheme from '@mui/material/styles/useTheme';
import React from 'react';
import { errorNotification } from '../../../config/disclaimers/disclaimers';
import useSharedData from '../../../hooks/useSharedData.ts';
import { getModalDefaultStyle } from '../../../utilities/getFontValues';
import { URLS } from '../../../config/const/enums';

import * as Sentry from '@sentry/react';
import { useEffect } from 'react';

//----------------------------------------------------------------

export default function GenericErrorModal() {
  const theme = useTheme();
  const style = getModalDefaultStyle(theme);
  const { handleEventChange, showErrorModal, errorMessage } = useSharedData();

  const handleClose = () => {
    handleEventChange({
      name: 'showErrorModal',
      value: false,
    });
  };

  useEffect(() => {
    if (errorMessage != null) {
      Sentry.captureException(new Error(errorMessage));
    }
  }, []);

  return (
    <Modal open={showErrorModal}>
      <Box sx={style} data-identifier="generic-error-modal">
        <Section
          sx={{
            pl: { xs: 4, sm: 8 },
            pr: { xs: 4, sm: 8 },
            pt: { xs: 5 },
            mt: 0,
            mb: 0,
          }}
        >
          <Section sx={{ maxWidth: { xs: 448 }, mb: 4 }}>
            <Section sx={{ mt: 5, mb: { xs: 3, sm: 4 } }}>
              <Section sx={{ mb: 0 }}>
                <img
                  width="100%"
                  alt="Error Message"
                  src="https://www.allianzretireplus.com.au/content/dam/onemarketing/azau/allianz-life-dam/images/man_hitting_a_nail_with_hammer.svg"
                ></img>
              </Section>
            </Section>
          </Section>
        </Section>
        <Section sx={{ mt: 8, mx: 5 }}>
          <Typography variant="h3-bold">{errorNotification.IMPROVING_SERVICE}</Typography>
        </Section>
        <Section sx={{ mt: 5, mx: { xs: 5, sm: 8 } }}>
          <Typography variant="p3">{errorNotification.NOT_AVAILABLE_TRY_AGAIN}</Typography>
        </Section>
        <Section
          sx={{ mt: 6, mb: 8, px: 3 }}
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <ArrowBackIcon
            sx={{
              fontSize: 16,
              color: theme.palette.action.PrimaryAction600,
            }}
          />
          <Link href={URLS.ALLIANZ_LIFE_HOMEPAGE}>{errorNotification.RETURN_ALLIANZ_HOMEPAGE}</Link>
        </Section>
      </Box>
    </Modal>
  );
}
